// Util function to format URLs by replacing spaces and periods with "-"
export const formatUrlSegment = (segment: string = ''): string => {
  return (
    segment
      .replace(/&amp;/gi, ' and ')
      .replace(/%26/gi, ' and ')
      .replace(/&/g, ' and ')
      .replace(/'/g, '')
      .replace(/\s+|%20|\./g, '-')
      // Replace literal percent symbols (e.g. "100%") with a readable token.
      .replace(/%/g, '-percent')
      // Collapse repeated hyphens ("--") to a single hyphen.
      .replace(/-+/g, '-')
      .toLowerCase()
  )
}
